(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5309],{

/***/ 55309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13075);
/* harmony import */ var _styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _data_home__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44330);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);






var Perfect_Gift = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5___default().perfect_gift),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5___default().perfect_gift_header),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: _data_home__WEBPACK_IMPORTED_MODULE_3__/* .homeLinks.perfectGift.title */ .n.perfectGift.title
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row d-flex justify-content-center",
                        children: _data_home__WEBPACK_IMPORTED_MODULE_3__/* .homeLinks.perfectGift.images.map */ .n.perfectGift.images.map(function(v, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5___default().col_11),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: v.link,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5___default().gift_jwellery),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    src: v.image,
                                                    className: "img-fluid",
                                                    alt: v.name,
                                                    width: 204,
                                                    height: 312
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5___default().gift_text),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5___default().h3_sub),
                                                        children: v.name
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center pt-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: _data_home__WEBPACK_IMPORTED_MODULE_3__/* .homeLinks.perfectGift.link */ .n.perfectGift.link,
                            className: (_styles_perfect_gift_module_scss__WEBPACK_IMPORTED_MODULE_5___default().btn_get_started),
                            children: "Explore All Gifts"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Perfect_Gift);


/***/ }),

/***/ 13075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"perfect_gift":"perfect_gift_perfect_gift__EmpLx","perfect_gift_header":"perfect_gift_perfect_gift_header__3q9Vn","col_11":"perfect_gift_col_11__mBTpu","gift_jwellery":"perfect_gift_gift_jwellery__KbmsT","gift_text":"perfect_gift_gift_text__6tlW5","h3_sub":"perfect_gift_h3_sub___DICx","btn_get_started":"perfect_gift_btn_get_started__on6sI","d_block_hover":"perfect_gift_d_block_hover__EC8TT"};

/***/ })

}]);